export interface Monitor {
  id: number;
  friendlyName: string;
  url: string;
  status: string; // String values like "UP", "DOWN", "PAUSED"
  type: string;
  interval: number;
  createDateTime: string;
  currentStateDuration: number;
  lastIncidentId?: string;
  userId: number;
  tags: string[];
  assignedAlertContacts: any[];
  lastIncident?: {
    id: string;
    status: string;
    cause: number;
    reason: string;
    startedAt: string;
    duration: number;
  } | null;
  lastDayUptimes: {
    bucketSize: number;
    histogram: any[];
  };
  groupId: number;
  regionalData?: Record<string, any>;
}

export interface StatusResponse {
  nextLink: string | null;
  data: Monitor[];
  date_updated: string;
}

// Helper function to get status class for styling
export function getStatusClass(status: string): string {
  const statusUpper = status.toUpperCase();
  switch (statusUpper) {
    case 'UP':
      return 'up';
    case 'DOWN':
      return 'down';
    case 'PAUSED':
      return 'paused';
    default:
      return 'unknown';
  }
}

// Helper function to get human-readable status text
export function getStatusText(status: string): string {
  const statusUpper = status.toUpperCase();
  switch (statusUpper) {
    case 'UP':
      return 'Up';
    case 'DOWN':
      return 'Down';
    case 'PAUSED':
      return 'Paused';
    default:
      return status;
  }
}
